import styled from 'styled-components';

const TestimonialContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    @media (max-width: 767px) {
        flex-direction: column;
        text-align: center;
    }
    img {
        width: 100px;
        border-radius: 50%;
        margin-right: 50px;
        @media (max-width: 767px) {
            margin: 0 auto 20px;
        }
    }
    .text {
        line-height: 1.8;
        border-bottom: 1px solid #ccc;
        p {
            color: #777;
            text-align: right;
            font-size: 14px;
            margin-bottom: 10px;
        }
    }
`;
export default TestimonialContainer;
